import { STRING_getInstance7xungxdjbzv as STRING_getInstance } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx } from '../../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { charArrayOf27f4r3dozbrk1 as charArrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import {
  indexOfAny2ijjuuzpljsyd as indexOfAny,
  substringAfterLast3r0t0my8cpqhk as substringAfterLast,
  substringBefore3n7kj60w69hju as substringBefore,
  contains2el4s70rdq4ld as contains,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { Companion_getInstance29buwn7hkq75x as Companion_getInstance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/LocalDateTime.mjs';
import { substringiqarkczpya5m as substring } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringJs.mjs';
import {
  FixedOffsetTimeZone3oldrgkltiv4z as FixedOffsetTimeZone,
  Companion_getInstance13ujfby7pfhe7 as Companion_getInstance_0,
  toInstant2ixtmlbww6j32 as toInstant,
  offsetAt16yxz78htuv90 as offsetAt,
  toInstant1fmt1re8uidf7 as toInstant_0,
  toLocalDateTime2fafgh396r2y5 as toLocalDateTime,
} from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/TimeZone.mjs';
import { Companion_getInstance2fuogtt2v1evi as Companion_getInstance_1 } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/UtcOffset.mjs';
import { charCodeAt1yspne1d8erbm as charCodeAt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { System_instance34rnn1q53nv02 as System_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Clock.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var OffsetDateTimeIso8601SerializerClass;
function OffsetDateTimeIso8601Serializer() {
  if (OffsetDateTimeIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        OffsetDateTimeIso8601Serializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('com.lightningkite.services.data.OffsetDateTime', STRING_getInstance());
      }
      deserialize_sy6x50_k$(decoder) {
        // Inline function 'com.lightningkite.services.data.deserializing' call
        var tmp;
        try {
          tmp = Companion_instance_0.parse_pc1q8p_k$(decoder.decodeString_x3hxsx_k$());
        } catch ($p) {
          var tmp_0;
          if ($p instanceof SerializationException()) {
            var e = $p;
            throw e;
          } else {
            if ($p instanceof Exception()) {
              var e_0 = $p;
              throw SerializationException().new_kotlinx_serialization_SerializationException_pjmzgo_k$('Not a valid ' + this.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + ': ' + e_0.message, e_0);
            } else {
              throw $p;
            }
          }
        }
        return tmp;
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_gcdwg6_k$(encoder, value) {
        return encoder.encodeString_424b5v_k$(value.toString());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_gcdwg6_k$(encoder, value instanceof OffsetDateTime() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'OffsetDateTimeIso8601Serializer', VOID, VOID, [KSerializer()]);
    OffsetDateTimeIso8601SerializerClass = $;
  }
  return OffsetDateTimeIso8601SerializerClass;
}
var OffsetDateTimeIso8601Serializer_instance;
function OffsetDateTimeIso8601Serializer_getInstance() {
  if (OffsetDateTimeIso8601Serializer_instance === VOID)
    new (OffsetDateTimeIso8601Serializer())();
  return OffsetDateTimeIso8601Serializer_instance;
}
var ZonedDateTimeIso8601SerializerClass;
function ZonedDateTimeIso8601Serializer() {
  if (ZonedDateTimeIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        ZonedDateTimeIso8601Serializer_instance = this;
        this.descriptor_1 = PrimitiveSerialDescriptor('com.lightningkite.services.data.ZonedDateTime', STRING_getInstance());
      }
      deserialize_sy6x50_k$(decoder) {
        // Inline function 'com.lightningkite.services.data.deserializing' call
        var tmp;
        try {
          tmp = Companion_instance.parse_pc1q8p_k$(decoder.decodeString_x3hxsx_k$());
        } catch ($p) {
          var tmp_0;
          if ($p instanceof SerializationException()) {
            var e = $p;
            throw e;
          } else {
            if ($p instanceof Exception()) {
              var e_0 = $p;
              throw SerializationException().new_kotlinx_serialization_SerializationException_pjmzgo_k$('Not a valid ' + this.get_descriptor_wjt6a0_k$().get_serialName_u2rqhk_k$() + ': ' + e_0.message, e_0);
            } else {
              throw $p;
            }
          }
        }
        return tmp;
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      serialize_yvoltj_k$(encoder, value) {
        return encoder.encodeString_424b5v_k$(value.toString());
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_yvoltj_k$(encoder, value instanceof ZonedDateTime() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'ZonedDateTimeIso8601Serializer', VOID, VOID, [KSerializer()]);
    ZonedDateTimeIso8601SerializerClass = $;
  }
  return ZonedDateTimeIso8601SerializerClass;
}
var ZonedDateTimeIso8601Serializer_instance;
function ZonedDateTimeIso8601Serializer_getInstance() {
  if (ZonedDateTimeIso8601Serializer_instance === VOID)
    new (ZonedDateTimeIso8601Serializer())();
  return ZonedDateTimeIso8601Serializer_instance;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      parse_pc1q8p_k$(string) {
        // Inline function 'kotlin.charArrayOf' call
        var tmp$ret$0 = charArrayOf([_Char___init__impl__6a9atx(90), _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(43), _Char___init__impl__6a9atx(45)]);
        var dateTimeFinishedIndex = indexOfAny(string, tmp$ret$0, 14);
        if (dateTimeFinishedIndex === -1)
          dateTimeFinishedIndex = string.length;
        return new (ZonedDateTime())(Companion_getInstance().parse$default_rpbnp3_k$(substring(string, 0, dateTimeFinishedIndex)), dateTimeFinishedIndex === string.length ? Companion_getInstance_0().UTC_1 : contains(string, _Char___init__impl__6a9atx(91)) ? Companion_getInstance_0().of_5gnbr7_k$(substringBefore(substringAfterLast(string, _Char___init__impl__6a9atx(91)), _Char___init__impl__6a9atx(93))) : charCodeAt(string, dateTimeFinishedIndex) === _Char___init__impl__6a9atx(90) ? Companion_getInstance_0().UTC_1 : FixedOffsetTimeZone().new_kotlinx_datetime_FixedOffsetTimeZone_pnfpw_k$(Companion_getInstance_1().parse$default_j5dbmh_k$(substring(string, dateTimeFinishedIndex, string.length))));
      }
      serializer_9w0wvi_k$() {
        return ZonedDateTimeIso8601Serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_2() {
  return Companion_instance;
}
var ZonedDateTimeClass;
function ZonedDateTime() {
  if (ZonedDateTimeClass === VOID) {
    class $ {
      constructor(dateTime, zone) {
        this.dateTime_1 = dateTime;
        this.zone_1 = zone;
      }
      compareTo_1sxkxm_k$(other) {
        return this.toInstant_4v91ie_k$().compareTo_stdc3w_k$(other.toInstant_4v91ie_k$());
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_1sxkxm_k$(other instanceof ZonedDateTime() ? other : THROW_CCE());
      }
      toString() {
        return this.dateTime_1.toString() + offsetAt(this.zone_1, toInstant(this.dateTime_1, this.zone_1)).toString() + '[' + this.zone_1.get_id_kntnx8_k$() + ']';
      }
      get_date_wokkxj_k$() {
        return this.dateTime_1.date_1;
      }
      get_time_wouyhi_k$() {
        return this.dateTime_1.time_1;
      }
      toInstant_4v91ie_k$() {
        return toInstant(this.dateTime_1, this.zone_1);
      }
      hashCode() {
        var result = this.dateTime_1.hashCode();
        result = imul(result, 31) + this.zone_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ZonedDateTime()))
          return false;
        if (!this.dateTime_1.equals(other.dateTime_1))
          return false;
        if (!this.zone_1.equals(other.zone_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ZonedDateTime', VOID, VOID, [Comparable()], VOID, VOID, {0: ZonedDateTimeIso8601Serializer_getInstance});
    ZonedDateTimeClass = $;
  }
  return ZonedDateTimeClass;
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      parse_pc1q8p_k$(string) {
        // Inline function 'kotlin.charArrayOf' call
        var tmp$ret$0 = charArrayOf([_Char___init__impl__6a9atx(90), _Char___init__impl__6a9atx(91), _Char___init__impl__6a9atx(43), _Char___init__impl__6a9atx(45)]);
        var dateTimeFinishedIndex = indexOfAny(string, tmp$ret$0, 14);
        if (dateTimeFinishedIndex === -1)
          dateTimeFinishedIndex = string.length;
        return new (OffsetDateTime())(Companion_getInstance().parse$default_rpbnp3_k$(substring(string, 0, dateTimeFinishedIndex)), dateTimeFinishedIndex === string.length ? Companion_getInstance_1().ZERO_1 : contains(string, _Char___init__impl__6a9atx(91)) ? offsetAt(Companion_getInstance_0().of_5gnbr7_k$(substringBefore(substringAfterLast(string, _Char___init__impl__6a9atx(91)), _Char___init__impl__6a9atx(93))), System_instance.now_2cba_k$()) : charCodeAt(string, dateTimeFinishedIndex) === _Char___init__impl__6a9atx(90) ? Companion_getInstance_1().ZERO_1 : Companion_getInstance_1().parse$default_j5dbmh_k$(substring(string, dateTimeFinishedIndex, string.length)));
      }
      serializer_9w0wvi_k$() {
        return OffsetDateTimeIso8601Serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_3() {
  return Companion_instance_0;
}
var OffsetDateTimeClass;
function OffsetDateTime() {
  if (OffsetDateTimeClass === VOID) {
    class $ {
      constructor(dateTime, offset) {
        this.dateTime_1 = dateTime;
        this.offset_1 = offset;
      }
      compareTo_u7anwd_k$(other) {
        return this.toInstant_4v91ie_k$().compareTo_stdc3w_k$(other.toInstant_4v91ie_k$());
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_u7anwd_k$(other instanceof OffsetDateTime() ? other : THROW_CCE());
      }
      toString() {
        return this.dateTime_1.toString() + this.offset_1.toString();
      }
      toInstant_4v91ie_k$() {
        return toInstant_0(this.dateTime_1, this.offset_1);
      }
      hashCode() {
        var result = this.dateTime_1.hashCode();
        result = imul(result, 31) + this.offset_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof OffsetDateTime()))
          return false;
        if (!this.dateTime_1.equals(other.dateTime_1))
          return false;
        if (!this.offset_1.equals(other.offset_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'OffsetDateTime', VOID, VOID, [Comparable()], VOID, VOID, {0: OffsetDateTimeIso8601Serializer_getInstance});
    OffsetDateTimeClass = $;
  }
  return OffsetDateTimeClass;
}
function nowLocal(_this__u8e3s4) {
  return new (ZonedDateTime())(toLocalDateTime(_this__u8e3s4.now_2cba_k$(), Companion_getInstance_0().currentSystemDefault_9rduv_k$()), Companion_getInstance_0().currentSystemDefault_9rduv_k$());
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_0 = new (Companion_0())();
//endregion
//region block: exports
export {
  OffsetDateTime as OffsetDateTime32mkjohqthyxu,
  ZonedDateTime as ZonedDateTime3ek76vws9u4no,
  nowLocal as nowLocal3kwskrm67145u,
  Companion_instance_0 as Companion_instance45cl7eqbjvkq,
  OffsetDateTimeIso8601Serializer_getInstance as OffsetDateTimeIso8601Serializer_getInstance1wmrj50dhqyob,
  Companion_instance as Companion_instance1awt21sjla5gi,
  ZonedDateTimeIso8601Serializer_getInstance as ZonedDateTimeIso8601Serializer_getInstance11y1vnw7kq0m4,
};
//endregion

//# sourceMappingURL=ZonedDateTime.mjs.map
